import * as React from 'react';

import {Button} from 'shells/button/button';
import {GridList} from 'shells/grid-list/grid-list';
import {Illustration} from 'shells/illustrations/illustration';
import {Stack} from 'shells/layout/stack/stack';
import {LoadingPage} from 'shells/loading-page/loading-page';
import {Body} from 'shells/typography/body';
import {ModalHeader} from 'shells/typography/modal-header';
import {ModalSubheader} from 'shells/typography/modal-subheader';

import {ConnectStep} from '../../../setup/connection-next-steps/connect-step';
import {useGetConnectNextSteps} from '../../../setup/connection-next-steps/graphql/hooks/use-get-connect-next-steps';
import {getConnectStepConfig} from '../../../setup/connection-next-steps/helpers';

import styles from './email-calendar-sync-completion-page.module.css';

type Props = {
    onClose: () => void;
};

export function EmailCalendarSyncCompletionPage(props: Props) {
    const {connectNextSteps, isLoading} = useGetConnectNextSteps();

    if (isLoading || !connectNextSteps) {
        return (
            <div className={styles['loading-container']}>
                <LoadingPage padding={64} fullHeight={true} />
            </div>
        );
    }

    const connectStepsMapped = connectNextSteps.nextSteps
        .map((step) => getConnectStepConfig(step))
        .filter(Boolean)
        .slice(0, 3);

    return (
        <>
            <div className={styles['illustration-container']}>
                <Illustration src='trial-onboarding/calendar-emails' />
            </div>
            <div className='flex flex-dir-col justify-sb pad-32 full-height'>
                <div>
                    <ModalHeader>Great job! Your email and calendar are connected!</ModalHeader>
                    <ModalSubheader>
                        You can now sync activities and emails to Nutshell and let others schedule
                        meetings with you through Scheduler
                    </ModalSubheader>
                    {connectStepsMapped.length > 0 && (
                        <Stack spacing={16}>
                            <Body size='large' color='dark' isBold={true}>
                                Connect other communication tools
                            </Body>
                            <GridList numColumns={2}>
                                {connectStepsMapped.map((step) => (
                                    <ConnectStep
                                        // @ts-expect-error
                                        key={step.description}
                                        // @ts-expect-error
                                        step={step}
                                        onClose={props.onClose}
                                    />
                                ))}
                            </GridList>
                        </Stack>
                    )}
                </div>
                <div className='flex justify-end mt-32'>
                    <Button variant='primary' size='big' onClick={props.onClose}>
                        Done
                    </Button>
                </div>
            </div>
        </>
    );
}
